import { render } from "./LoginUser.vue?vue&type=template&id=4bd8d8d9"
import script from "./LoginUser.vue?vue&type=script&lang=js"
export * from "./LoginUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/teo/git_repos/cancer-classifier-app/cancer-classifier-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__